import { Container } from 'components/container';
import { SectionHeader } from 'components/Section';
import parse from 'html-react-parser';
import { Section } from './index.styled';
import data from './data.json';
import Footer from 'components/footer';
import PreLoading from 'components/pre-loading';

const DestinationsPage = () => {
  return (
    <>
      <PreLoading label="DESTINATIONS" />
      <Section>
        <div className="col-12">
          <img alt="destination 1" className="col-6" src="assets/images/drgn/destination_1.jpg" />
          <img alt="destination 2" className="col-6" src="assets/images/drgn/destination_2.jpg" />
        </div>
        <div className="col-12">
          <img alt="destination 3" className="col-6" src="assets/images/drgn/destination_3.jpg" />
          <img alt="destination 4" className="col-6" src="assets/images/drgn/destination_4.jpg" />
        </div>
        <div className="col-12">
          <img alt="destination 5" className="col-6" src="assets/images/drgn/destination_5.jpg" />
          <img alt="destination 6" className="col-6" src="assets/images/drgn/destination_6.jpg" />
        </div>
        <Container>
          <div className="grid">
            <div className="col-12 md:col-8 md:col-offset-2">
              <SectionHeader className="text-center" label="" title="EXCLUSIVE OFF MARKET DGRN PROPERTIES" />
            </div>
          </div>

          <div className="grid mt-5">
            {data.map((item, k) => (
              <div key={k}>
                <p>{parse(item.text)}</p>
              </div>
            ))}
          </div>
        </Container>
      </Section>
      <Footer />
    </>
  );
};
export default DestinationsPage;
